import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { NetworkRequiredPage } from './network-required.page';

const routes: Routes = [
  {
    path: '',
    component: NetworkRequiredPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NetworkRequiredPageRoutingModule {}
